import { Grid, IconButton, TextField, withStyles, Typography } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import clsx from 'clsx';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const styles = (theme) => ({
    section: {
        background: '#F8F8F8',
        paddingBottom: theme.spacing(2),
    },
    alignEnd: {
        textAlign: 'end',
    },
    grey: {
        color: '#484848',
        paddingLeft: theme.spacing(3),
    },
    resultMappingField: {
        width: '30%',
    },
    draggableChoice: {
        padding: theme.spacing(0.5, 3, 1, 0),
        display: 'flex',
        alignItems: 'center',
    },
    choice: {
        '&:hover': {
            backgroundColor: 'rgb(189, 189, 189, 0.1)',
        },
        '&:hover $dragIcon': {
            visibility: 'visible',
        },
    },
    drag: {
        backgroundColor: 'rgb(189, 189, 189, 0.1)',
        '&:active $dragIcon': {
            visibility: 'visible',
        },
    },
    dragIcon: {
        visibility: 'hidden',
        height: 'auto',
    },
    draggableGrid: {
        padding: theme.spacing(1),
    },
    whiteBackground: {
        backgroundColor: 'white',
        width: '30%',
    },
});

const emptyRow = { field: '', title: '', mapping: '' };
class ResultMappingSection extends React.Component {
    state = {
        resultMappings: this.props.resultMappings?.length
            ? this.props.resultMappings
            : [
                  { field: '', title: '', mapping: '' },
                  { field: '', title: '', mapping: '' },
              ],
    };

    addRow(index) {
        const resultMappings = [
            ...this.state.resultMappings.slice(0, index + 1),
            { field: '', title: '', mapping: '' },
            ...this.state.resultMappings.slice(index + 1),
        ];
        const target = {
            id: 'resultMappings',
            value: resultMappings,
        };
        this.setState({ resultMappings });
        this.props.handleChange({ target });
    }

    deleteRow(index) {
        if (this.state.resultMappings.length > 1) {
            const resultMappings = [
                ...this.state.resultMappings.slice(0, index),
                ...this.state.resultMappings.slice(index + 1),
            ];
            const target = {
                id: 'resultMappings',
                value: resultMappings,
            };
            this.setState({ resultMappings });
            this.props.handleChange({ target });
        } else {
            const resultMappings = [];
            resultMappings.push(emptyRow);
            const target = {
                id: 'resultMappings',
                value: resultMappings,
            };
            this.setState({ resultMappings });
            this.props.handleChange({ target });
        }
    }

    handleChangeTextInput = (event, index) => {
        const resultMappings = this.state.resultMappings;
        if (event.target.id === 'headerLabel') {
            resultMappings[index].title = event.target.value;
        }
        if (event.target.id === 'returnedData') {
            resultMappings[index].field = event.target.value;
        }
        const target = {
            id: 'resultMappings',
            value: resultMappings,
        };
        this.setState({ resultMappings });
        this.props.handleChange({ target });
    };

    handleChangeAutocompleteInput = (newValue, index) => {
        const resultMappings = this.state.resultMappings;
        resultMappings[index].mapping = newValue;
        const target = {
            id: 'resultMappings',
            value: resultMappings,
        };
        this.setState({ resultMappings });
        this.props.handleChange({ target });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        let resultMappings = [...this.state.resultMappings];
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }
        const choice = resultMappings[source.index];
        resultMappings.splice(source.index, 1);
        resultMappings.splice(destination.index, 0, choice);
        const target = {
            id: 'resultMappings',
            value: resultMappings,
        };
        this.setState({ resultMappings });
        this.props.handleChange({ target });
    };

    render() {
        const { resultMappings } = this.state;

        return (
            <React.Fragment>
                <Grid className={this.props.classes.section}>
                    <Typography className={this.props.classes.grey}>Columns Displayed</Typography>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        {resultMappings?.length > 0 && (
                            <Droppable droppableId="searchPropertiesDroppable">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {resultMappings.map((choice, index) => (
                                            <Draggable
                                                key={`searchProperty-${index}`}
                                                draggableId={`draggableRow ${index}`}
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <div
                                                        className={clsx(this.props.classes.draggableChoice, {
                                                            [this.props.classes.drag]: snapshot.isDragging,
                                                            [this.props.classes.choice]: !snapshot.isDragging,
                                                        })}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        <DragIndicatorIcon
                                                            className={this.props.classes.dragIcon}
                                                            color="action"
                                                        />
                                                        <Grid
                                                            item
                                                            container
                                                            className={this.props.classes.draggableGrid}
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                        >
                                                            <TextField
                                                                id="headerLabel"
                                                                size="small"
                                                                variant="outlined"
                                                                value={choice.title ?? ''}
                                                                label="Header Label"
                                                                className={this.props.classes.whiteBackground}
                                                                onChange={(e) => this.handleChangeTextInput(e, index)}
                                                            />
                                                            <TextField
                                                                variant="outlined"
                                                                id="returnedData"
                                                                label="Returned Data"
                                                                size="small"
                                                                value={choice.field ?? ''}
                                                                className={this.props.classes.whiteBackground}
                                                                onChange={(e) => this.handleChangeTextInput(e, index)}
                                                            />
                                                            <Autocomplete
                                                                id="resultMappings"
                                                                value={choice.mapping ?? ''}
                                                                className={this.props.classes.whiteBackground}
                                                                options={this.props.multipleSubFields}
                                                                getOptionLabel={(option) => {
                                                                    if (typeof option === 'string') {
                                                                        return option;
                                                                    }
                                                                    return option.field;
                                                                }}
                                                                onChange={(event, newValue, reason) => {
                                                                    if (reason === 'clear') {
                                                                        this.handleChangeAutocompleteInput(null, index);
                                                                    } else {
                                                                        this.handleChangeAutocompleteInput(
                                                                            newValue.field,
                                                                            index,
                                                                        );
                                                                    }
                                                                }}
                                                                renderOption={(option) => option.field}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Autofill Field Name"
                                                                        size="small"
                                                                        variant="outlined"
                                                                    />
                                                                )}
                                                            />
                                                            <Grid alignItems="center" justifyContent="center">
                                                                <IconButton
                                                                    size="small"
                                                                    aria-label="add"
                                                                    onClick={() => this.addRow(index)}
                                                                >
                                                                    <AddCircleOutlineIcon />
                                                                </IconButton>
                                                                <IconButton
                                                                    size="small"
                                                                    aria-label="remove"
                                                                    onClick={() => this.deleteRow(index)}
                                                                >
                                                                    <RemoveCircleOutlineIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        )}
                    </DragDropContext>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(ResultMappingSection);
